import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { Apis, BaseUrl } from "../../../redux/config";
import { WebsiteLayout } from "../../../../components/Layouts/WebsiteLayout";
import FullScreenLoader from "../../../FullScreenLoader";

const SharedCart = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(decodeURIComponent(location.search));
  const paramsObj = [...params].reduce((acc, item) => {
    acc[item[0]] = item[1];
    return acc;
  }, {});

  const [data, setData] = useState({});
  const tempRef = useRef(
    JSON.parse(sessionStorage.getItem("payment_user_details"))
  );
  const cartItems = data.serviceOrderLines || [];

  const total =
    cartItems?.length > 0 &&
    cartItems.reduce((sum, item) => sum + Number(item?.svc_price_amt), 0);

  const [sessionUrl, setSessionUrl] = useState("");
  const [paymentType, setPaymentType] = useState("full");
  const [partialAmount, setPartialAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("stripe");

  const [paymentInitialised, setPaymentInitialised] = useState(false);

  const handlePartialAmountChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value) && value >= 0) {
      if (Number(value) > data.serviceOrder?.balance || 0) {
        setPartialAmount(data.serviceOrder?.balance || 0);
      } else {
        setPartialAmount(value);
      }
    }
  };

  const handleSubmitPay = async () => {
    setPaymentInitialised(true);
    const postData = {
      ord_svc_date: data.serviceOrder.ord_svc_date,
      ord_svc_time: data.serviceOrder.ord_svc_time,
      order_tot_tax: 0,
      order_tot_fees: 0,
      order_svcf_id: paramsObj.user,
      user_profile_id: paramsObj.user,
      order_ship_to_id: 2,
      order_ship_instructions: "",
      order_bill_to_id: 2,
      paymentType,
      order_status_id: 1,
      sys_user_id: paramsObj.user,
      sys_source_ip: "192.168.2.2",
      sys_ord_active_yn: "Y",
      payment_method: paymentMethod,
      order_id: data.serviceOrder.order_id || "",
      payee_name: tempRef.current.payee_name,
      payee_email: tempRef.current.payee_email,
      order_payment_amt:
        paymentType === "partial" ? partialAmount : data.serviceOrder.balance,
      payee_phone: tempRef.current.payee_phone,
    };

    try {
      let response;
      response = await axios.post(
        `${BaseUrl}${Apis.partialPayment}`,
        postData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      sessionStorage.removeItem("payment_user_details");
      sessionStorage.removeItem("orderId");
      if (paymentMethod === "wallet") {
        setSessionUrl("/health/payment-success");
      } else {
        setSessionUrl(response?.data?.session_url);
      }
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    } finally {
      setPaymentInitialised(false);
    }
  };

  const isInsufficientBalance =
    paymentType !== "partial" && tempRef.current?.wallet_balance < total;

  const getData = async (link = "") => {
    try {
      const fullUrl = `${BaseUrl}${Apis.getSharePaymentOrder}?link=${link}`;

      const response = await axios.get(fullUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      setData(response.data);
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    }
  };

  useEffect(() => {
    if (sessionUrl) {
      window.location.href = sessionUrl;
    }
    const link =
      "https://cyrixservices.com/health/share_payment" +
      encodeURIComponent(location.search);

    getData(link);
    sessionStorage.setItem("orderId", JSON.stringify(paramsObj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, sessionUrl]);

  return (
    <WebsiteLayout className={"bg-lightGray min-h-[60vh]"}>
      <FullScreenLoader isLoading={paymentInitialised} />

      <div className="px-[0.75rem] sm:px-8 pt-15 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-wrap m-0">
          Cart ({(cartItems && cartItems.length) || 0})
        </h5>
      </div>

      {!paramsObj.user ? (
        <div className="flex gap-16 sm:!px-9 m-0 mt-5">
          <p className="text-red-500 w-full text-2xl font-semibold text-center">
            Invalid Session
          </p>
        </div>
      ) : cartItems.length > 0 ? (
        <div className="flex md:flex-row flex-col lg:gap-16 gap-8  md:!px-9 !px-4 m-0 mt-5 pb-10">
          <div className="md:w-[70%] w-full">
            <div className="w-fit flex gap-2 items-center">
              <div className="text-white bg-[#1340CD] rounded-[5px] h-5 w-5 text-sm text-center"></div>
              <p className="m-0 text-sm text-[#1340CD] font-medium">
                Review selected services
              </p>
            </div>
            <div className="list mt-4 pb-4 ">
              {data.serviceOrderLines.map((item, index) => (
                <div className="border-b border-b-gray-300 pb-3" key={index}>
                  <div className="flex justify-between w-full items-center mt-2 ">
                    <div className="flex items-center gap-3">
                      <Icon
                        icon="streamline-emojis:hospital"
                        style={{ fontSize: "50px" }}
                      />
                      <div className="mt-3">
                        <h2 className="text-[18px] font-medium m-0">
                          #{item?.svc_id} {item?.svc_name}
                        </h2>
                        {item?.ord_svc_date && (
                          <h2 className="text-base font-medium m-0 text-gray-500">
                            {item?.ord_svc_date}, {item?.ord_svc_time}
                          </h2>
                        )}

                        {item.order_ship_instructions && (
                          <>
                            <span className="text-base font-medium">
                              Special Instructions:
                            </span>{" "}
                            <span className="text-gray-500">
                              {item.order_ship_instructions}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center gap-3 mt-[2px]">
                      <h4 className="text-[18px] font-semibold m-0 text-black">
                        ${item?.svc_price_amt}
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-white shadow-md rounded-lg p-6">
              <h2 className="text-xl font-semibold mb-4">
                Transaction History
              </h2>
              <div className="overflow-auto">
                <table className="w-full border-collapse border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2">
                        Transaction ID
                      </th>
                      <th className="border border-gray-300 px-4 py-2">User</th>
                      <th className="border border-gray-300 px-4 py-2">
                        Amount
                      </th>
                      <th className="border border-gray-300 px-4 py-2">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.walletTransactions?.map((transaction) => (
                      <tr
                        key={transaction.wallet_transaction_id}
                        className="text-center"
                      >
                        <td className="border border-gray-300 px-4 py-2">
                          {transaction.wallet_transaction_id}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          {transaction.user_profile.user_first_name}{" "}
                          {transaction.user_profile.user_last_name}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          ${transaction.amount}
                        </td>
                        <td
                          className={`border border-gray-300 px-4 py-2 font-semibold ${
                            transaction.status === "completed"
                              ? "text-green-600"
                              : "text-red-600"
                          }`}
                        >
                          {transaction.status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="h-fit md:w-[30%] w-full pb-3">
            <div className="bg-gray-100 py-4 bg-white p-4 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold">
                Selected Services Summary
              </h2>

              {/* Actual Total Cost */}
              <div className="flex justify-between items-center mt-3">
                <p className="text-gray-500">Proposed Total</p>
                <p className="font-semibold">
                  ${total ? Number(total).toFixed(2) : "0.00"}
                </p>
              </div>

              {/* Balance Remaining to be Paid */}
              <div className="flex justify-between items-center ">
                <p className="text-gray-500">Balance to be Paid</p>
                <p className="font-semibold">
                  $
                  {data?.serviceOrder?.balance
                    ? Number(data.serviceOrder.balance).toFixed(2)
                    : "0.00"}
                </p>
              </div>

              {/* If Partial Payment, Show Amount to Pay Now and Later */}
              {paymentType === "partial" && (
                <>
                  <div className="flex justify-between items-center">
                    <p className="text-gray-500">Amount to be Paid Later</p>
                    <p className="font-semibold">
                      $
                      {(
                        Number(data.serviceOrder.balance) - partialAmount
                      ).toFixed(2)}
                    </p>
                  </div>
                </>
              )}

              {/* Final Total Confirmation */}
              <div className="flex justify-between items-center mt-4">
                <p className="text-gray-500">Final Total</p>
                <p className="font-semibold">
                  $
                  {partialAmount
                    ? Number(partialAmount).toFixed(2)
                    : Number(data.serviceOrder?.balance || 0).toFixed(2)}
                </p>
              </div>
            </div>

            <div className="mt-4 flex flex-col w-full justify-end gap-2 bg-white p-4 rounded-lg shadow-md">
              {tempRef.current ? (
                <>
                  <div>
                    <div className="flex justify-between gap-4 items-center">
                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          disabled={paymentInitialised}
                          type="checkbox"
                          name="paymentMethod"
                          value="partial"
                          checked={paymentType === "partial"}
                          onChange={({ target }) => {
                            const { checked } = target;
                            if (!checked) {
                              setPartialAmount(0);
                            }
                            setPaymentType(checked ? "partial" : "full");
                          }}
                        />
                        Pay Partially
                      </label>
                    </div>

                    {paymentType === "partial" && (
                      <div className="mt-2 mb-4">
                        <input
                          disabled={paymentInitialised}
                          type="number"
                          className="form-control border p-2 w-full rounded-md"
                          placeholder="Enter amount"
                          value={partialAmount}
                          onChange={handlePartialAmountChange}
                        />
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-2 justify-center items-center">
                    <div className="flex flex-col items-center w-full text-center">
                      <label
                        className={`flex items-center gap-1 w-full rounded-md border text-sm justify-center p-[12px] ${
                          paymentMethod === "stripe"
                            ? "border-blue-500"
                            : "border-gray-300"
                        }`}
                      >
                        <input
                          disabled={paymentInitialised}
                          type="radio"
                          name="paymentMethod"
                          value="stripe"
                          checked={paymentMethod === "stripe"}
                          onChange={() => setPaymentMethod("stripe")}
                        />
                        Credit/Debit Card
                      </label>
                    </div>
                    <div className="flex flex-col items-center w-full text-center">
                      {tempRef.current?.isLogged ? (
                        <label
                          className={`flex items-center gap-1 w-full rounded-md border text-sm justify-center p-2  ${
                            isInsufficientBalance
                              ? "cursor-not-allowed !text-[#769895] bg-gray-200"
                              : "bg-white border-gray-300"
                          }`}
                        >
                          <input
                            disabled={
                              isInsufficientBalance || paymentInitialised
                            }
                            type="radio"
                            name="paymentMethod"
                            value="wallet"
                            checked={paymentMethod === "wallet"}
                            onChange={() => setPaymentMethod("wallet")}
                          />
                          <Icon
                            icon="material-symbols-light:account-balance-wallet-outline"
                            className="size-6"
                          />
                          E-Wallet
                          {isInsufficientBalance && (
                            <p className="!text-[#769895] !text-xs m-0">
                              (Insufficient Balance)
                            </p>
                          )}
                        </label>
                      ) : null}
                      <p className="text-green-600 text-xs font-semibold mt-1">
                        Get 5% discount on paying via Wallet!
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-2 w-full">
                    <button
                      disabled={paymentInitialised}
                      className="bg-[#1340CD] border border-gray-300 py-2 px-2 !rounded-md text-sm text-white w-full"
                      onClick={handleSubmitPay}
                    >
                      Checkout
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex flex-col w-full justify-end gap-2">
                    <button
                      className="bg-[#1340CD] border border-gray-300 py-2 px-3 !rounded-md text-sm text-white"
                      onClick={() => history.push(`/sharedLogin`)}
                    >
                      Pay After Login
                    </button>
                    <button
                      className="bg-[#1340CD] border border-gray-300 py-2 px-3 !rounded-md text-sm text-white"
                      onClick={() => history.push(`/cartLogin`)}
                    >
                      Pay Without Login
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex gap-16 sm:!px-9 m-0 mt-5">
          <p className="text-red-500 w-full text-2xl font-semibold text-center">
            Your cart is empty!
          </p>
        </div>
      )}
    </WebsiteLayout>
  );
};

export default SharedCart;
